import { MdArrowForwardIos } from 'react-icons/md';

import RestexInformes from '../../components/restez-informes/RestexInformes';
import Meilleur from '../../components/Meilleur/Meilleur';
import { Link } from 'react-router-dom';

const Rse = () => {
  return (
    <>
      <div className="wrapper flex flex-col gap-[8px] mb-[40px]">
        <div className="content flex gap-[12px] md:gap-[24px] items-center w-full py-[16px] 1400:px-0 px-[16px]">
          <p className="text-dark cursor-pointer transition">
            <Link to="/">Accueil</Link>
          </p>
          <MdArrowForwardIos className="text-[#9EA5A7] text-[12px]" />
          <p className="text-dark cursor-pointer transition">RSE</p>
        </div>
        <div className="content flex flex-col md:gap-[24px] sm:gap-[30px] lg:gap-[80px] md:py-[22px] 1400:px-0 px-[16px]">
          <a href="https://carlife-tycoon.fr/" target="_blank" className="mb-10 md:mb-5">
            <img src="/centres_VHU_banner_1456x180.png" alt="Bannière centres VHU" className="hidden md:block" />
            <img src="/centres_VHU_banner_600x500.png" alt="Bannière centres VHU" className="block md:hidden w-full max-w-[600px] mx-auto" />
          </a>
          <div className="flex-col gap-[12px] lg:gap-[48px] hidden md:flex">
            <h1 className="font-clash text-[40px] sm:text-[50px] leading-[1] 900:text-[80px] 900:leading-[64px] font-[600] text-dark">
              Notre démarche RSE
            </h1>
            <div className="flex  border-b-2 border-blue w-96 "></div>
          </div>
          <h2 className="font-clash text-[25px] sm:text-[40px] leading-[1] 900:text-[60px] 900:leading-[64px] font-[600] text-dark">
            Un engagement sociétal et environnemental fort
          </h2>
          <div className="mt-2">
            <p className="text-[18px] md:text-[25px] mb-5 md:mb-10">
              Nous sommes partenaires du réseau de centres VHU de <a href="https://www.recyclermonvehicule.fr/" target="_blank" className='text-blue underline'>RecyclerMonVéhicule</a>, l’éco-organisme agréé par le <a href="https://www.ecologie.gouv.fr/" target="_blank" className='text-blue underline'>Ministère en charge de l’environnement</a> pour garantir le recyclage et la valorisation des véhicules hors d’usage à plus de 95% et donner ainsi une seconde vie aux pièces et aux matériaux qui composent les véhicules.
            </p>
            <p className="text-[18px] md:text-[25px]">
              A ce titre nous nous engageons à : <br />
              <ul className="list-disc list-inside">
                <li>Apporter un service de proximité au consommateur</li>
                <li>Garantir la conformité environnementale du réemploi et du recyclage des véhicules qui nous sont confiés</li>
                <li>Contribuer à l’atteinte en France des objectifs de réemploi des pièces des véhicules</li>
                <li>Développer l’économie circulaire</li>
                <li>Assurer la traçabilité et le reporting nécessaire au pilotage des performances de la filière et à son amélioration continue</li>
              </ul>
            </p>
          <img alt="partenaire-recycler-mon-véhicule-centre-vhu" className="mt-10 md:mt-15 lg:mt-10 w-full max-w-[700px] mx-auto lg:max-w-none" srcSet="/rmv_reseau-1920x1080.webp 1920w, /rmv_reseau-1080x1080.webp 1023w" />
          </div>

          <div className="border-[1px] sm:col-span-4 1100:col-span-2 border-[#0d1f2229] bg-[#7EBC89] bg-opacity-30 rounded-[13px]  p-[10px] sm:p-[20px] xl:p-[30px] relative overflow-hidden mt-5 md:mt-0">
            <div className="flex flex-col gap-[12px] sm:gap-[15px] xl:gap-[24px] 100:max-w-[440px]">
              <div className="flex justify-center sm:flex-col items-center sm:items-start gap-[10px] sm:gap-[15px] xl:gap-[24px] min-h-[224px]">
                <img
                  src="/recycle.png"
                  alt=""
                  className="absolute h-full max-w-[337px] top-0 right-[-40px] sm:right-[14%]   "
                />

                <h2 className="font-clash font-[500] text-dark md:text-[30px] text-[24px] p-3 leading-[42px]">
                  Le taux global de réutilisation et de valorisation{' '}
                  <br className="hidden md:block" />
                  atteint par notre entreprise et notre broyeur{' '}
                  <br className="hidden md:block" />
                  agréé s'élève à : <span className="font-[600]">99.44%</span>
                  <br className="hidden md:block" />
                  (obligation réglementaire : 95 %)
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="content flex flex-col md:gap-[24px] sm:gap-[30px] lg:gap-[80px] md:py-[22px] 1400:px-0 px-[16px]">
          <Meilleur />
        </div>
      </div>

      <RestexInformes />
    </>
  );
};

export default Rse;
